import {
  CarouselButton,
  CarouselButtonWrapper,
  CarouselInner,
  CarouselMainContainer,
  CarouselWrapper,
} from 'components/storybook-migration/Carousel/Carousel.styled';
import { CarouselProps } from 'components/storybook-migration/Carousel/Carousel.types';
import React, { useState } from 'react';
import { useSwipeable } from 'react-swipeable';

const Carousel = ({ children, contentStyle = {}, ...props }: CarouselProps) => {
  const [activeIndex, setActiveIndex] = useState(0);

  const changeCarouselItem = (newIndex: number) =>
    setActiveIndex(
      Math.max(0, Math.min(React.Children.count(children) - 1, newIndex)),
    );

  const swipingHandlers = useSwipeable({
    onSwipedLeft: () => changeCarouselItem(activeIndex + 1),
    onSwipedRight: () => changeCarouselItem(activeIndex - 1),
  });

  return (
    <CarouselMainContainer
      style={{
        ...contentStyle,
      }}
      {...props}
    >
      <CarouselWrapper data-testid="carousel-wrapper" {...swipingHandlers}>
        <CarouselInner
          style={{ transform: `translateX(-${activeIndex * 100}%)` }}
        >
          {children}
        </CarouselInner>
      </CarouselWrapper>
      <CarouselButtonWrapper aria-label="carousel-pagination">
        {React.Children.map(children, (child, index) => {
          return (
            <CarouselButton
              data-testid={`carousel-button-${index + 1}`}
              aria-label={`Carousel item ${index + 1}`}
              aria-current={activeIndex === index}
              $active={activeIndex === index}
              onClick={() => {
                changeCarouselItem(index);
              }}
            />
          );
        })}
      </CarouselButtonWrapper>
    </CarouselMainContainer>
  );
};

export default Carousel;
